<p-panel>
  <div
    *ngIf="reaReviewNotice !== ''"
    class="rea-review-form-notice"
    role="status"
    aria-live="polite"
  >
    <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
    <div>
      <strong>Revisión REA pendiente</strong>
      <p>{{ reaReviewNotice }}</p>
    </div>
  </div>

  <app-reactive-form-builder
    #formbuilder
    (formChanges)="formChanges($event[0], $event[1])"
    (goBack)="goBack()"
    (afterSend)="afterSend($event)"
    [form]="form.formFields"
    [serverUrl]="''"
    [dropdownLoadTrigger]="dropdownLoadTrigger"
    [dropdownsFinalized]="dropdownsFinalized"
    [id]="getModel().id"
    [request]="
      this.getType() === 1
        ? this.fincasApi.parcelasPUT
        : this.fincasApi.parcelasPOST
    "
    [getRequest]="this.fincasApi.parcelasGET"
  >
  </app-reactive-form-builder>
</p-panel>

<p-dialog
  [header]="'Mapa ' + form.parcelaNombre"
  [(visible)]="form.mapaAbierto"
  #mapaDialog
  (onShow)="scrollToTop()"
  [style]="{ width: '80vw' }"
  [appendTo]="'body'"
  [modal]="true"
  [style]="{'height': '75vh', 'width': '80vw'}"
>
  <div class="relative w-100 h-100">
    <app-mapa-add
      [origin]="origin"
      [finca]="form.finca"
      [localidad]="form.localidad"
      [cultivo]="form.cultivo"
      [variedad]="form.variedad"
      [parcelaNombre]="form.parcelaNombre"
      (fromMapa)="getFromMapa($event)">
    </app-mapa-add>
  </div>
</p-dialog>

<app-dialog-sigpac-form
  #sigpac
  (sendSigPac)="getSigPac($event)"
></app-dialog-sigpac-form>

<p-dialog
  [(visible)]="form.openDialog"
  [modal]="true"
  [dismissableMask]="true"
  header="Añadir valor"
  [style]="{ width: '28rem' }"
>
  <div [formGroup]="comunidadForm" class="p-fluid">
    <div class="field">
      <label for="nombre">Nombre</label>
      <input
        id="nombre"
        pInputText
        formControlName="nombre"
      />
      <small
        *ngIf="comunidadForm.controls['nombre']?.invalid && comunidadForm.controls['nombre']?.touched"
        class="p-error"
      >
        Campo requerido
      </small>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="p-button-text" (click)="form.openDialog = false" label="Cancelar"></button>
    <button pButton type="button" (click)="saveNewOption()" label="Añadir" icon="pi pi-check"></button>
  </ng-template>
</p-dialog>
